import React from 'react';
import { theme } from '../../styles/theme';

// What's wrong with a cart line, by the server's `reason` (see the cart
// availability check in CartContext).
const PROBLEM_LABELS = {
  not_found: 'No longer available',
  inactive: 'No longer available',
  option_removed: 'The option you chose is no longer available',
  addon_unavailable: 'An add-on you chose is no longer available',
  out_of_stock: 'Out of stock',
};

export const cartProblemLabel = (status) => {
  if (status.reason === 'insufficient_stock') return `Only ${status.available_qty} left in stock`;
  return PROBLEM_LABELS[status.reason] || status.message || 'Not available right now';
};

// Notice on a cart line that can't be checked out as it is.
const CartItemNotice = ({ status }) => {
  if (!status || status.available) return null;
  const fix = status.reason === 'insufficient_stock'
    ? `Lower the quantity to ${status.available_qty} to check out.`
    : 'Remove it to check out.';
  return (
    <div
      role="alert"
      style={{
        margin: `${theme.spacing.xs} 0 ${theme.spacing.sm}`,
        padding: '8px 10px',
        borderRadius: theme.borderRadius.md,
        border: '1px solid #FCA5A5',
        backgroundColor: '#FEF2F2',
        color: '#991B1B',
        fontSize: theme.typography.fontSize.xs,
        lineHeight: 1.4,
      }}
    >
      <strong style={{ display: 'block' }}>{cartProblemLabel(status)}</strong>
      {fix}
    </div>
  );
};

export default CartItemNotice;
